import React, { memo, useMemo, useState } from 'react';
import { Box } from '@mui/material';
import { useStyles } from './select-category-dialog.style';
import { ProspectCategory } from 'src/app/modules/Prospect/types/prospect-types';
import PruDialog from 'src/app/common/components/PruDialog';
import { CategorySelectOption } from '../../../../../../common/components/universal-selector-dialog/select-option/select-option.component';
import { getI18nData } from 'src/app/common/utils/i18n.util';
import { useLang } from 'src/app/i18n';
import { useTranslation } from 'src/app/common/hooks/translation.hook';

type ComponentProps = {
  open: boolean;
  onConfirm?: (prospectCategories: ProspectCategory[], index: number) => void;
  onClose?: () => void;
  prospectCategories?: ProspectCategory[];
  loading?: boolean;
};

export const SelectCategoryDialog: React.FC<ComponentProps> = memo(
  ({ open, prospectCategories, onConfirm, onClose, loading }: ComponentProps) => {
    const { t: Translation } = useTranslation();
    const locale = useLang();

    // style
    const { classes } = useStyles();
    const styles = useMemo(() => classes, [classes]);

    const [selected, setSelected] = useState(0); // selected first

    return (
      <PruDialog
        open={open}
        dialogTitle={Translation('pruleads.prospect.list.editCategory')}
        confirmBtnText={Translation('app.button.confirm')}
        canncelBtnText={Translation('app.button.cancel')}
        onOk={() => {
          onConfirm?.(prospectCategories!, selected);
        }}
        onCancel={() => {
          onClose?.();
        }}
        loading={loading}
      >
        <Box className={styles.container}>
          {prospectCategories
            ?.filter(({ type }) => type !== 'None')
            .map((category, index) => {
              const {
                name: initName,
                description: initDesc,
                type,
                colorLabel: color,
                backgroundColorLabel: backgroundColor,
              } = category;
              const name = getI18nData(initName, locale);
              const description = getI18nData(initDesc, locale);
              return (
                <CategorySelectOption
                  key={index}
                  option={{ name, description, type, color, backgroundColor }}
                  selected={selected}
                  index={index}
                  className={`${styles.mt24} ${selected === index ? styles.activeBg : ''}`}
                  onClick={(index) => {
                    if (selected !== index) {
                      setSelected(index);
                    }
                  }}
                />
              );
            })}
        </Box>
      </PruDialog>
    );
  },
);
